import React from "react";
import { Controller, Control } from "react-hook-form";
import { TextField, Typography, Theme, SxProps } from "@mui/material";
import { normalizeDecimalInput } from "../config/number";

type Props = {
  editable: boolean;

  // edit mode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<any>;
  name?: string;

  // read mode
  value?: string | number;

  inputSx?: SxProps<Theme>;
  currency?: string;
};

export const PriceField = React.memo(
  ({ editable, control, name, value, inputSx, currency = "USD" }: Props) => {
    if (editable && control && name) {
      return (
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField
              value={field.value === "0" ? "0" : (field.value ?? "")}
              type="text"
              inputMode="decimal"
              size="small"
              sx={{ maxWidth: 120 }}
              onChange={(e) => {
                const raw = normalizeDecimalInput(e.target.value);

                if (raw === "") {
                  field.onChange("");
                  return;
                }

                field.onChange(raw);
              }}
              slotProps={{
                input: {
                  sx: inputSx,
                  endAdornment: (
                    <Typography variant="caption" sx={{ ml: 0.5 }}>
                      {currency}
                    </Typography>
                  ),
                },
              }}
            />
          )}
        />
      );
    }

    return (
      <Typography variant="body1" fontWeight={600} textAlign="right">
        {value} {currency}
      </Typography>
    );
  },
);
